module.exports = __webpack_public_path__ + "static/media/dump.d3eca61a.svg";